import { NeoModel, Attributes, ModelBase } from '@singularsystems/neo-core';
@NeoModel
export default class SecurityHoldingLookup extends ModelBase {

    public clientAccount: string = "";

    public rawAccountNumber: string = "";

    public instrumentDescription: string = "";

    public tickerSymbol: string = "";

    public instrument: string = "";

    public isin: string | null = null;

    @Attributes.Date()
    public reportDate: Date | null = null;

    public quantity: number | null = null;

    public instrumentCurrency: string = "";

    public priceFactor: number | null = null;

    public value: number | null = null;

    public valueUSD: number | null = null;

    public portfolioBookPriceTC: number | null = null;
}